<p-overlayPanel
    #op
    styleClass="start-new-order-options"
    [focusOnShow]="true"
    (onShow)="onMenuShow()"
    (onHide)="closeMenu()">
    <nav id="start-new-order-options" (keyup.escape)="closeMenu()" aria-label="Start New Order Options">
        <a
            id="genotyping-link"
            autofocus
            [class.disabled]="isOrderSetupActive()"
            [attr.aria-disabled]="isOrderSetupActive()"
            [attr.tabindex]="isOrderSetupActive() ? -1 : 0"
            aria-label="Start Genotyping Order"
            (click)="handleGenotypingClick($event)"
            (keyup.enter)="handleGenotypingClick($event)">
            <div>
                <i class="fa-solid fa-angles-right"></i>
                <label id="genotyping-label">Genotyping</label>
            </div>
        </a>

        <a
            id="genetic-monitoring-link"
            tabindex="0"
            aria-label="Go to Genetic Monitoring"
            (click)="handleGeneticMonitoringClick()"
            (keyup.enter)="handleGeneticMonitoringClick()">
            <div>
                <i class="fa-solid fa-angles-right"></i>
                <label for="genetic-monitoring-icon" id="genetic-monitoring-label">{{
                    'orders.tabs.geneticMonitoring' | translate
                }}</label>
            </div>
        </a>

        <a
            id="microbiome-link"
            tabindex="0"
            aria-label="Go to Microbiome"
            (click)="handleMicrobiomeClick()"
            (keyup.enter)="handleMicrobiomeClick()">
            <div>
                <i class="fa-solid fa-angles-right"></i>
                <label for="microbiome-icon" id="microbiome-label">{{ 'orders.tabs.microbiome' | translate }}</label>
            </div>
        </a>
    </nav>
</p-overlayPanel>

<ui-button
    [id]="'start-new-order'"
    [label]="'orders.startOrder'"
    [icon]="'fa-sharp fa-solid fa-cart-shopping'"
    (onClick)="op.toggle($event)"></ui-button>
